import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ActiveFiltersBadgeProps {
  numberOfFilters: number;
  className?: string;
}

const ActiveFiltersBadge: React.FC<ActiveFiltersBadgeProps> = ({ numberOfFilters, className = '' }) => {
  return (
    <div
      className={twMerge(
        'flex h-5 w-5 items-center justify-center rounded-full bg-ph-primary-violet text-ph-gray-white',
        className,
      )}
    >
      <p className="text-xs font-extrabold">{numberOfFilters}</p>
    </div>
  );
};

export default ActiveFiltersBadge;
